(function() {
    'use strict';

    const $body = document.body;

    // Helper to access halo functions
    function getHalo() {
        return window.halo || {};
    }

    const addToCart = {
        initAddToCart: function () {
            document.addEventListener('click', (event) => {
                const target = event.target.closest('[data-btn-addtocart]');
                if (!target) return;

                event.preventDefault();
                event.stopPropagation();

                const product = target.closest('.product-item');
                const MobilePopup_Option_2 = document.querySelector('#halo-card-mobile-popup');
                const ProductQuickShopShown_Option_2 = document.querySelector('.quickshop-popup-show');

                const productFormEl = document.body.querySelector('product-form');
                const halo = getHalo();
                if (productFormEl) {
                    const productForm = productFormEl.querySelector('form');
                    const addToCartBtn = productFormEl.querySelector('form #product-add-to-cart');
                    if (halo.actionAddToCart2) {
                        halo.actionAddToCart2(addToCartBtn, productForm);
                    }
                } else {
                    if (!target.classList.contains('is-notify-me') && !target.classList.contains('is-soldout')) {
                        const form = target.closest('form');
                        if (!form) return;
                        const variantIdInput = form.querySelector('[name="id"]');
                        const qtyInput = form.querySelector('[name="quantity"]');
                        const variantId = variantIdInput ? variantIdInput.value : null;
                        const qty = qtyInput ? qtyInput.value : 1;
                        const input = form.querySelector('[name="quantity"]');
                        if (qty == undefined) {
                            qty = 1;
                        }

                        const recipientForm = document.querySelector('.recipient-form');
                        if (recipientForm) {
                            const productAddToCart = document.querySelector('#product-add-to-cart');
                            if (productAddToCart) productAddToCart.click();
                        } else {
                            if (halo.actionAddToCart) {
                                halo.actionAddToCart(target, variantId, qty, input);
                            }
                        }

                    } else if (target.classList.contains('is-notify-me')) {
                        if (halo.notifyInStockPopup) {
                            halo.notifyInStockPopup(target);
                        }
                    }
                }
            });

            document.addEventListener('click', (event) => {
                const closeBtn = event.target.closest('[data-close-add-to-cart-popup]');
                if (closeBtn) {
                    event.preventDefault();
                    event.stopPropagation();
                    document.body.classList.remove('add-to-cart-show');
                }
            });

            document.addEventListener('click', (event) => {
                if (document.body.classList.contains('add-to-cart-show')) {
                    if (!event.target.closest('[data-add-to-cart-popup]')) {
                        document.body.classList.remove('add-to-cart-show');
                    }
                }
            });
        },

        actionAddToCart: function ($target, variantId, qty, input) {
            var originalMessage = window.variantStrings.submit,
                waitMessage = window.variantStrings.addingToCart,
                successMessage = window.variantStrings.addedToCart;

            const targetEl = $target instanceof Element ? $target : ($target && $target[0] ? $target[0] : $target);
            if (targetEl && targetEl.classList.contains('button-text-change')) {
                originalMessage = targetEl.textContent || targetEl.innerText;
            }

            if (targetEl) targetEl.classList.add('is-loading');

            const halo = getHalo();

            if ($body.classList.contains('quick-view-show')) {
                Shopify.addItem(variantId, qty, $target, () => {
                    switch (window.after_add_to_cart.type) {
                        case 'cart':
                            if (halo.redirectTo) {
                                halo.redirectTo(window.routes.cart);
                            }

                            break;
                        case 'quick_cart':
                            if (window.quick_cart.show) {
                                Shopify.getCart((cart) => {
                                    if (window.quick_cart.type == 'popup') {
                                    } else {
                                    $body.classList.add('cart-sidebar-show');
                                    if (halo.updateSidebarCart) {
                                        halo.updateSidebarCart(cart);
                                    }
                                }
                                if (cart.item_count >= 100) {
                                    const cartCount = document.querySelector('.cart-count-bubble [data-cart-count]');
                                    if(cartCount) cartCount.textContent = window.cartStrings.item_99;
                                }

                                if ($target) $target.classList.remove('is-loading');
                                document.querySelectorAll('.background-overlay').forEach(overlay => overlay.classList.remove('hold'));
                                });
                            } else {
                                if (halo.showWarning) {
                                    halo.showWarning(window.after_add_to_cart.message_2);
                                }
                                if ($target) $target.classList.remove('is-loading');
                                Shopify.getCart((cart) => {
                                    const cartCounts = document.querySelectorAll('[data-cart-count]');
                                    cartCounts.forEach(el => el.textContent = cart.item_count);
                                    if (cart.item_count >= 100) {
                                        const cartCountBubble = document.querySelector('.cart-count-bubble [data-cart-count]');
                                        if(cartCountBubble) cartCountBubble.textContent = window.cartStrings.item_99;
                                    }
                                    const cartTexts = document.querySelectorAll('[data-cart-text]');
                                    cartTexts.forEach(el => {
                                        el.textContent = cart.item_count == 1 ? window.cartStrings.item : window.cartStrings.items;
                                    });
                                });
                            }

                            break;
                        case 'popup_cart_1':
                            Shopify.getCart((cart) => {
                                if (halo.updatePopupCart) {
                                    halo.updatePopupCart(cart, 1, variantId);
                                }
                                //halo.updateSidebarCart(cart);
                                $body.classList.add('add-to-cart-show');
                                $body.classList.remove('quick-view-show');
                                if ($target) $target.classList.remove('is-loading');
                                if (cart.item_count >= 100) {
                                    const cartCount = document.querySelector('.cart-count-bubble [data-cart-count]');
                                    if(cartCount) cartCount.textContent = window.cartStrings.item_99;
                                }
                                document.querySelectorAll('.background-overlay').forEach(overlay => overlay.classList.remove('hold'));
                            });

                            break;
                    }
                }, input);
            } else if ($body.classList.contains('template-cart')) {
                Shopify.addItem(variantId, qty, $target, () => {
                    // $target.text(successMessage);
                    if (halo.redirectTo) {
                        halo.redirectTo(window.routes.cart);
                    }
                }, input);
            } else {
                Shopify.addItem(variantId, qty, $target, () => {
                    // $target.text(successMessage);
                    if ($target) $target.classList.remove('is-loading');
                    if ($body.classList.contains('quickshop-popup-show') && $body.classList.contains('quick_shop_option_3')) {
                        $body.classList.remove('quickshop-popup-show');
                        document.querySelectorAll('.quickshop-popup-show').forEach(el => el.classList.remove('quickshop-popup-show'));
                    }

                    if ($body.classList.contains('quickshop-list-view-show')) {
                        $body.classList.remove('quickshop-list-view-show');
                    }

                    if ($body.classList.contains('show-mobile-options')) {
                        $body.classList.remove('show-mobile-options');
                        document.querySelectorAll('.background-overlay').forEach(overlay => overlay.classList.add('hold'));
                    }

                    if (($body.classList.contains('quick_shop_popup_mobile') && $body.classList.contains('quick_shop_option_1')) || $body.classList.contains('quick_shop_option_2')) {
                        $body.classList.remove('quick_shop_popup_mobile');
                        const mobilePopup = document.getElementById('halo-card-mobile-popup');
                        if(mobilePopup) mobilePopup.classList.remove('show');
                        document.querySelectorAll('.quickshop-popup-show').forEach(popup => {
                            popup.classList.remove('quickshop-popup-show');
                        });
                        // }, 200);
                    }

                    switch (window.after_add_to_cart.type) {
                        case 'cart':
                            if (halo.redirectTo) {
                                halo.redirectTo(window.routes.cart);
                            }

                            break;
                        case 'quick_cart':
                            if (window.quick_cart.show) {
                                Shopify.getCart((cart) => {
                                    if (window.quick_cart.type == 'popup') {
                                    } else {
                                        $body.classList.add('cart-sidebar-show');
                                        if (halo.updateSidebarCart) {
                                            halo.updateSidebarCart(cart);
                                        }
                                    }
                                    if ($target) $target.classList.remove('is-loading');
                                    document.querySelectorAll('.background-overlay').forEach(overlay => overlay.classList.remove('hold'));
                                    if (cart.item_count >= 100) {
                                        const cartCount = document.querySelector('.cart-count-bubble [data-cart-count]');
                                        if(cartCount) cartCount.textContent = window.cartStrings.item_99;
                                    }
                                });

                            } else {
                                if (halo.showWarning) {
                                    halo.showWarning(window.after_add_to_cart.message_2);
                                }
                                Shopify.getCart((cart) => {
                                    const cartCounts = document.querySelectorAll('[data-cart-count]');
                                    cartCounts.forEach(el => el.textContent = cart.item_count);
                                    if (cart.item_count >= 100) {
                                        const cartCountBubble = document.querySelector('.cart-count-bubble [data-cart-count]');
                                        if(cartCountBubble) cartCountBubble.textContent = window.cartStrings.item_99;
                                    }
                                    const cartTexts = document.querySelectorAll('[data-cart-text]');
                                    cartTexts.forEach(el => {
                                        el.textContent = cart.item_count == 1 ? window.cartStrings.item : window.cartStrings.items;
                                    });
                                });
                            }

                            break;
                        case 'popup_cart_1':
                            Shopify.getCart((cart) => {
                                if (halo.updatePopupCart) {
                                    halo.updatePopupCart(cart, 1, variantId);
                                }
                                $body.classList.add('add-to-cart-show');
                                if ($target) $target.classList.remove('is-loading');
                                document.querySelectorAll('.background-overlay').forEach(overlay => overlay.classList.remove('hold'));
                                if (cart.item_count >= 100) {
                                    const cartCount = document.querySelector('.cart-count-bubble [data-cart-count]');
                                    if(cartCount) cartCount.textContent = window.cartStrings.item_99;
                                }
                            });

                            break;
                    }
                }, input);
            }
        },

        actionAddToCart2: function ($target, productForm) {
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            var originalMessage = window.variantStrings.submit,
                waitMessage = window.variantStrings.addingToCart,
                successMessage = window.variantStrings.addedToCart;

            const targetEl = $target instanceof Element ? $target : ($target && $target[0] ? $target[0] : $target);
            if (targetEl && targetEl.classList.contains('button-text-change')) {
                originalMessage = targetEl.textContent || targetEl.innerText;
            }

            if (targetEl) targetEl.classList.add('is-loading');

            let addToCartForm = document.querySelector('[data-type="add-to-cart-form"]');
            let formData = new FormData(addToCartForm);

            // Log para debug: verificar estado do window.selecionadas no início
            console.log('FormData criado. window.selecionadas:', window.selecionadas ? Array.from(window.selecionadas) : 'não existe');

            const properties = document.querySelectorAll('.line-item-property__field [name^="properties"]')

            properties.forEach(property => {
                if (property.value == null) return;
                if (property.type == 'file') {
                    formData.append(property.name, property.files[0])
                } else {
                    formData.append(property.name, property.value)
                }
            })

            // Adicionar inputs de peças selecionadas (painéis)
            // Usar window.selecionadas diretamente para garantir que todos sejam adicionados
            const pecasAdicionadas = [];
            if (window.selecionadas && window.selecionadas.size > 0) {
                window.selecionadas.forEach(numero => {
                    const input = document.querySelector(`#peca-${numero}`);
                    if (input) {
                        formData.append(input.name, input.value);
                        pecasAdicionadas.push({ name: input.name, value: input.value, numero: numero });
                    }
                });
            }

            // Também verificar inputs marcados como fallback
            const pecaInputs = document.querySelectorAll('.peca-input:checked');
            console.log('Inputs de peças encontrados via seletor:', pecaInputs.length);
            console.log('Peças do window.selecionadas:', window.selecionadas ? Array.from(window.selecionadas) : 'não existe');
            console.log('Peças adicionadas ao FormData:', pecasAdicionadas);

            const halo = getHalo();
            const enoughInStock = halo.checkSufficientStock ? halo.checkSufficientStock(productForm) : true;
            if (!enoughInStock && $body.classList.contains('quickshop-popup-show')) {
                alert(window.cartStrings.addProductOutQuantity);
                if (targetEl) targetEl.classList.remove('is-loading');
                return
            }

            const addItemToCart = (variantId) => {
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    ...config, ...{
                        method: 'POST',
                        body: formData
                    }
                })
                    .then(response => {
                        return response.json();
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
                    .finally(() => {
                        if ($body.classList.contains('quickshop-popup-show')) {
                            $body.classList.remove('quickshop-popup-show');
                        }

                        if ($body.classList.contains('quick-view-show')) {
                            if (window.after_add_to_cart.type == 'cart') {
                                if (halo.redirectTo) {
                                    halo.redirectTo(window.routes.cart);
                                }
                            } else {
                                Shopify.getCart((cartTotal) => {
                                    document.querySelectorAll('[data-cart-count]').forEach(el => {
                                        el.textContent = cartTotal.item_count;
                                    });
                                    if (targetEl) targetEl.classList.remove('is-loading');
                                    if (cartTotal.item_count >= 100) {
                                        const cartCountBubble = document.querySelector('.cart-count-bubble [data-cart-count]');
                                        if (cartCountBubble) cartCountBubble.textContent = window.cartStrings.item_99;
                                    }
                                });
                            }
                        } else {
                            switch (window.after_add_to_cart.type) {
                                case 'cart':
                                    if (halo.redirectTo) {
                                        halo.redirectTo(window.routes.cart);
                                    }

                                    break;
                                case 'quick_cart':
                                    if (window.quick_cart.show) {
                                        Shopify.getCart((cart) => {
                                            if (window.quick_cart.type == 'popup') {
                                                // $body.classList.add('cart-modal-show');
                                                // halo.updateDropdownCart(cart);
                                            } else {
                                                $body.classList.add('cart-sidebar-show');
                                                if (halo.updateSidebarCart) {
                                                    halo.updateSidebarCart(cart);
                                                }
                                            }
                                            if (cart.item_count >= 100) {
                                                const cartCountBubble = document.querySelector('.cart-count-bubble [data-cart-count]');
                                                if (cartCountBubble) cartCountBubble.textContent = window.cartStrings.item_99;
                                            }
                                            if (targetEl) targetEl.classList.remove('is-loading');
                                        });
                                    } else {
                                        if (halo.redirectTo) {
                                            halo.redirectTo(window.routes.cart);
                                        }
                                    }

                                    break;
                                case 'popup_cart_1':
                                    Shopify.getCart((cart) => {
                                        if (halo.updatePopupCart) {
                                            halo.updatePopupCart(cart, 1, variantId);
                                        }
                                        if (halo.updateSidebarCart) {
                                            halo.updateSidebarCart(cart);
                                        }
                                        $body.classList.add('add-to-cart-show');
                                        if (targetEl) targetEl.classList.remove('is-loading');
                                        if (cart.item_count >= 100) {
                                            const cartCountBubble = document.querySelector('.cart-count-bubble [data-cart-count]');
                                            if (cartCountBubble) cartCountBubble.textContent = window.cartStrings.item_99;
                                        }
                                    });

                                    break;
                            }
                        }

                        const panelSelection = document.getElementById('panel-selection-container');
                        if (panelSelection) {
                            // Fechar Fancybox após um pequeno delay para garantir que o FormData foi criado
                            setTimeout(() => {
                                if (typeof Fancybox !== 'undefined') Fancybox.close();
                            }, 100);
                        }
                    });
            }

            fetch(window.Shopify.routes.root + 'cart.js', {
                method: 'GET',
            })
                .then(response => {
                    return response.json();
                }).then(response => {
                    // Convert jQuery serialize to vanilla JS
                    const formData = new FormData(addToCartForm);
                    const formEntries = Array.from(formData.entries());
                    const idEntry = formEntries.find(([key]) => key === 'id');
                    const variantId = idEntry ? parseInt(idEntry[1]) : null;

                    const item = response.items.find(item => item.variant_id == variantId)
                    const currentQuantity = item?.quantity
                    const currentProductId = item?.product_id
                    const inventoryQuantityEl = productForm instanceof Element ? productForm : productForm[0] || productForm;
                    const inventoryQuantityInput = inventoryQuantityEl.querySelector('[data-inventory-quantity]');
                    const moreQuantity = inventoryQuantityInput ? parseInt(inventoryQuantityInput.value) : 0;
                    const maxQuantity = inventoryQuantityInput ? parseInt(inventoryQuantityInput.dataset.inventoryQuantity) : 0;
                    const saleOutStock = document.getElementById('product-add-to-cart').dataset.available === 'true' | false

                    if (!currentQuantity || !maxQuantity || saleOutStock) return addItemToCart(variantId)
                    var arrayInVarName = `selling_array_${currentProductId}`,
                        itemInArray = window[arrayInVarName],
                        itemStatus = itemInArray[variantId];
                    if (itemStatus == 'deny') {
                        if (currentQuantity + moreQuantity > maxQuantity) {
                            if (maxQuantity < 0) {
                                addItemToCart(variantId);
                            } else {
                                const remainingQuantity = maxQuantity - currentQuantity
                                throw new Error(`You ${remainingQuantity > 0 ? `can only add ${remainingQuantity}` : 'cannot add'} more of the items into the cart`)
                            }
                        } else {
                            addItemToCart(variantId);
                        }
                    } else {
                        addItemToCart(variantId);
                    }
                }).catch(err => {
                    const halo = getHalo();
                    if (halo.showWarning) {
                        halo.showWarning(err);
                    }
                }).finally(() => {
                    if ($target instanceof Element) {
                        $target.classList.remove('is-loading');
                    } else if ($target && $target[0]) {
                        $target[0].classList.remove('is-loading');
                    }
                })
        },

        checkSufficientStock: function (productForm) {
            const productFormEl = productForm instanceof Element ? productForm : productForm[0] || productForm;
            const inventoryQuantityEl = productFormEl.querySelector('[data-inventory-quantity]');
            const maxValidQuantity = inventoryQuantityEl ? parseInt(inventoryQuantityEl.dataset.inventoryQuantity) : 0;
            const inputQuantity = inventoryQuantityEl ? parseInt(inventoryQuantityEl.value) : 0;

            return maxValidQuantity >= inputQuantity
        }
    };

    // Attach to window.halo
    if (!window.halo) {
        window.halo = {};
    }

    // Attach all add to cart functions to halo
    Object.assign(window.halo, addToCart);

    // Auto-initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            addToCart.initAddToCart();
        });
    } else {
        addToCart.initAddToCart();
    }
})();

